export enum TopNavBarTabs {
    ALL_INSIGHTS = "All insights",
    YOUR_INSIGHT_DECKS = "Your insight decks",
    EXPLORE_WITH_AI = "Explore with AI",
}

export enum TabQueryParamValue {
    GENERATED_INSIGHTS = "generated",
    EXPLORE_WITH_AI = "exploreWithAI",
    ALL_INSIGHTS = "insights",
}
